<template>
  <div class="jim-scheduling-container">
    <h1 class="page-heading">Operations • Pricing</h1>

    <div class="menu-grid panel">
      <router-link class="option" to="/price-sheets">
        Price Sheets
      </router-link>

      <!-- future links go here -->
      <!-- <router-link class="option" to="/pricing/discounts">Discount Rules</router-link> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "OperationsPricing"
};
</script>

<style scoped>
.jim-scheduling-container {
  font-family: Garamond, serif;
  text-align: center;
  color: #cbbfbf;
  background-color: #0b0101;
  min-height: 100vh;
  padding: 20px 14px;
}

.page-heading {
  font-family: 'Cormorant Garamond', serif;
  font-size: 32px;
  color: #cbbfbf;
  margin-bottom: 18px;
}

.panel {
  background-color: #0b0101;
  border: 1px solid #888;
  border-radius: 10px;
  padding: 18px;
  max-width: 520px;
  margin: 0 auto;
}

.menu-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.option {
  display: block;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #444;
  background-color: #111827;
  color: #cbbfbf;
  text-decoration: none;
  font-weight: bold;
  transition: transform 0.12s ease, background-color 0.15s ease;
}

.option:hover {
  transform: translateY(-2px);
  background-color: #1f2933;
}
</style>
